module.exports = __webpack_public_path__ + "static/media/test12_1.1bc49b83.png";